// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 Copyright 2024 European Commission

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */

/*-------new version-------*/

body, html {
    height: 100%;
    padding: 0;
}
.container-fluid {
    height: 100%;
}
.login-form {
    background-color: #ffffff;
    padding: 20px;
    border-radius: 15px;
    min-width:500px;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
}
.login-image {
    background-size: cover;
    background-position: center;
}
#formCol{
    background: linear-gradient(#eb6823, #000000);
}


.btnOrange {
    background-color: #EB6823;
    color: white;
    border: 1px solid #EB6823;
    border-radius: 15px;
    transition: all 0.3s;
}

.btnOrange:hover {
    background-color: white;
    color: #EB6823;
    border: 1px solid #EB6823;
}

@media (max-width: 767.98px) {
    .login-image {
        display: none;
    }

    #formCol{
        background-size: cover;
        background-position: center;
    }
    
    .login-form{
        min-width: auto;
    }


}`, "",{"version":3,"sources":["webpack://./src/user/login/Login.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF,4BAA4B;;AAE5B;IACI,YAAY;IACZ,UAAU;AACd;AACA;IACI,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,4CAA4C;AAChD;AACA;IACI,sBAAsB;IACtB,2BAA2B;AAC/B;AACA;IACI,6CAA6C;AACjD;;;AAGA;IACI,yBAAyB;IACzB,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,2BAA2B;IAC/B;;IAEA;QACI,eAAe;IACnB;;;AAGJ","sourcesContent":["/*\r\n Copyright 2024 European Commission\r\n\r\n Licensed under the Apache License, Version 2.0 (the \"License\");\r\n you may not use this file except in compliance with the License.\r\n You may obtain a copy of the License at\r\n\r\n      https://www.apache.org/licenses/LICENSE-2.0\r\n\r\n Unless required by applicable law or agreed to in writing, software\r\n distributed under the License is distributed on an \"AS IS\" BASIS,\r\n WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\r\n See the License for the specific language governing permissions and\r\n limitations under the License.\r\n */\r\n\r\n/*-------new version-------*/\r\n\r\nbody, html {\r\n    height: 100%;\r\n    padding: 0;\r\n}\r\n.container-fluid {\r\n    height: 100%;\r\n}\r\n.login-form {\r\n    background-color: #ffffff;\r\n    padding: 20px;\r\n    border-radius: 15px;\r\n    min-width:500px;\r\n    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);\r\n}\r\n.login-image {\r\n    background-size: cover;\r\n    background-position: center;\r\n}\r\n#formCol{\r\n    background: linear-gradient(#eb6823, #000000);\r\n}\r\n\r\n\r\n.btnOrange {\r\n    background-color: #EB6823;\r\n    color: white;\r\n    border: 1px solid #EB6823;\r\n    border-radius: 15px;\r\n    transition: all 0.3s;\r\n}\r\n\r\n.btnOrange:hover {\r\n    background-color: white;\r\n    color: #EB6823;\r\n    border: 1px solid #EB6823;\r\n}\r\n\r\n@media (max-width: 767.98px) {\r\n    .login-image {\r\n        display: none;\r\n    }\r\n\r\n    #formCol{\r\n        background-size: cover;\r\n        background-position: center;\r\n    }\r\n    \r\n    .login-form{\r\n        min-width: auto;\r\n    }\r\n\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
